import React from 'react';
const Component2 = () => {
    return(
        <div>
            <h2>Nos objectifs<br/><b>2030</b></h2>
            <div className="row">
                <div className="col-4">
                    <h3>Recommandations de l'OMS pour la qualité de l'air</h3>
                    <p>respecter les recommandations fixées par l'organisation mondiale de la santé.</p>
                </div>
                <div className="col-4">
                    <h4>Gaz à effet de serre</h4>
                    <p>Légende Légende : lorem ipsum sed iristium copis arrivam iscidendur.</p>
                    <div className="row">
                        <div className="col-6">

                        </div>
                        <div className="col-6">
                            <b>-50%</b><br/>
                            des émissions de gaz à effet de serre sur notre parc.
                        </div>
                    </div>
                    <h4>Empreinte carbone</h4>
                    <p>Légende Légende : lorem ipsum sed iristium copis arrivam iscidendur.</p>
                    <div className="row">
                        <div className="col-6">

                        </div>
                        <div className="col-6">
                            <b>-50%</b><br/>
                            des émissions de gaz à effet de serre sur notre parc.
                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <h4>Enr</h4>
                    <p>Légende Légende : lorem ipsum sed iristium copis arrivam iscidendur.</p>
                    <div className="row">
                        <div className="col-6">

                        </div>
                        <div className="col-6">
                            <b>-50%</b><br/>
                            des émissions de gaz à effet de serre sur notre parc.
                        </div>
                    </div>
                    <h4>Consommations énergétiques</h4>
                    <p>Légende Légende : lorem ipsum sed iristium copis arrivam iscidendur.</p>
                    <div className="row">
                        <div className="col-6">

                        </div>
                        <div className="col-6">
                            <b>-50%</b><br/>
                            des émissions de gaz à effet de serre sur notre parc.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Component2;